__turbopack_context__.v({
  "clickable": "main-image-module__WsK3pG__clickable",
  "error": "main-image-module__WsK3pG__error",
  "tools": "main-image-module__WsK3pG__tools",
  "wrapper": "main-image-module__WsK3pG__wrapper",
});
